import React from "react";
import { FormattedMessage } from "react-intl";
function LocalizedText({ label, labelParams }) {
  return label ? /* @__PURE__ */ React.createElement(React.Fragment, null, typeof label === "string" ? label : /* @__PURE__ */ React.createElement(FormattedMessage, { ...label, values: labelParams })) : /* @__PURE__ */ React.createElement(React.Fragment, null);
}
export {
  LocalizedText
};
//# sourceMappingURL=LocalizedText.js.map
